import { render, staticRenderFns } from "./ProtocolsByPastPeriods.vue?vue&type=template&id=12b12e6a"
import script from "./ProtocolsByPastPeriods.vue?vue&type=script&lang=js"
export * from "./ProtocolsByPastPeriods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports